<template>
  <form
    class="store-form"
    action="#"
    method="post"
    @submit.prevent="handleSubmitAddress"
  >
    <input
      v-model="address"
      :placeholder="placeholder"
      inputmode="numeric"
      pattern="^(?(^00000(|-0000))|(\d{5}(|-\d{4})))$"
      class="map-input"
    >
    <button
      class="search"
      type="submit"
    >
      OK
    </button>
  </form>
</template>

<script>
import { gmapApi } from 'vue2-google-maps';

export default {
  data() {
    return {
      address: '',
      map: null,
    };
  },
  computed: {
    placeholder() {
      return this.$store.state.config.store.placeholder;
    },
    geocoder() {
      return new this.google.maps.Geocoder();
    },
    google: gmapApi,
  },
  mounted() {
  },
  methods: {
    handleSubmitAddress() {
      this.geocoder.geocode({ address: `${this.address} France` }, (results) => {
        this.$emit('searchMap', results);
      });
    },
  },
};
</script>

<style lang="stylus" scoped>

</style>

